import React from 'react'

type BackdropProps = {
  open: boolean // Controls whether the backdrop is visible
  onClick?: () => void // Handler for clicking on the backdrop
  className?: string // Optional additional styles
  style?: any // Optional additional styles
  children?: React.ReactNode // Optional children (e.g., spinner, message)
}

export const Backdrop: React.FC<BackdropProps> = ({
  open,
  onClick,
  className = '',
  style,
  children,
}) => {
  return (
    <div
      className={`fixed inset-0 z-40 bg-black/50 transition-opacity ${
        open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      } ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-center h-full" style={style}>
        {children}
      </div>
    </div>
  )
}